import { render, staticRenderFns } from "./NotResult.vue?vue&type=template&id=c483945e&scoped=true&"
var script = {}
import style0 from "./NotResult.vue?vue&type=style&index=0&id=c483945e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c483945e",
  null
  
)

export default component.exports